import conforms from "lodash/conforms";
import flow from "lodash/flow";
import get from "lodash/get";
import isArray from "lodash/isArray";
import isBoolean from "lodash/isBoolean";
import isString from "lodash/isString";
import inRange from "lodash/inRange";
import overEvery from "lodash/overEvery";
import size from "lodash/size";
import toFinite from "lodash/toFinite";

const isWorkingHoursEntry = conforms({
  enabled: isBoolean,
  workingHours: overEvery([
    isString,
    flow(toFinite, (n) => inRange(n, 0.0, 24.0))
  ]),
});

function isWorkingHours(arr) {
  if (isArray(arr) && size(arr) === 7) {
    return arr.every(isWorkingHoursEntry);
  }

  return false;
}

const SCHEMA = {
  confirmations: isBoolean,
  firstTimeLogin: isBoolean,
  notifications: isBoolean,
  workingHours: isWorkingHours,
};

const initialState = {
  workingHours: [
    { enabled: true, workingHours: "8.0" },
    { enabled: true, workingHours: "8.0" },
    { enabled: true, workingHours: "8.0" },
    { enabled: true, workingHours: "8.0" },
    { enabled: true, workingHours: "8.0" },
    { enabled: false, workingHours: "8.0" },
    { enabled: false, workingHours: "8.0" },
  ],
  notifications: true,
  confirmations: true,
  firstTimeLogin: true,
  initialState: true
};

export default function settings(state = initialState, action) {
  switch (action.type) {
  case "SET_USER_PREFERENCES": {
    // Validate schema
    const prefs = action.preferences;
    const newState = { ...state };

    for (const [key, predicate] of Object.entries(SCHEMA)) {
      const value = get(prefs, key);

      if (predicate(value)) {
        newState[key] = value;
      } else {
        console.info("invalid value for SET_USER_PREFERENCES[%s]", key);
        console.dir({ value });
      }
    }

    return newState;
  }
  case "SET_WORKING_HOURS":
    return { ...state, workingHours: action.days };
  case "SET_SETTINGS_TOGGLE":
    return {
      ...state,
      [action.key]: action.value
    };
  case "SET_FIRST_TIME_LOGIN":
    return { ...state, firstTimeLogin: action.firstTime };
  case "USER_DATA_LOADED":
    return { ...state, initialState: false };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/settings/index.js